import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/authProvider";
import Icon from "./AppIcon";

import logger from 'utils/logger';
const AdminRoute = ({ children, allowedRoles = ['ADMIN'] }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    // Se ainda está carregando, não fazer nada
    if (loading) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShouldRender(false);
      return;
    }

    // Se não está carregando, verificar permissões
    if (!user) {
      logger.log('AdminRoute: Usuário não encontrado, redirecionando...');
      navigate('/dash/user-dashboard', { replace: true });
      return;
    }

    if (!allowedRoles.includes(user.role)) {
      logger.log('AdminRoute: Role não permitida:', user.role, 'Permitidas:', allowedRoles);
      navigate('/dash/user-dashboard', { replace: true });
      return;
    }

    // Se chegou até aqui, tem permissão
    logger.log('AdminRoute: Acesso permitido para role:', user.role);
    setShouldRender(true);
  }, [user, loading, navigate, allowedRoles]);

  // Mostra loading enquanto está carregando ou verificando permissões
  if (loading || !shouldRender) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <Icon name="Loader" size={48} className="text-muted-foreground mx-auto mb-4 animate-spin" />
          <p className="text-muted-foreground">
            {loading ? "Carregando usuário..." : "Verificando permissões..."}
          </p>
        </div>
      </div>
    );
  }

  // Se não tem user ou role após carregamento, mostrar erro
  if (!user || !allowedRoles.includes(user.role)) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center max-w-md mx-auto p-8">
          <Icon name="Shield" size={48} className="text-red-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-foreground mb-2">
            Acesso Negado
          </h2>
          <p className="text-muted-foreground mb-4">
            Você não tem permissão para acessar esta área.
            Apenas administradores e membros da equipe de suporte podem acessar.
          </p>
          <button
            onClick={() => navigate('/dash/user-dashboard')}
            className="text-primary hover:text-primary/80 underline"
          >
            Voltar ao Dashboard
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default AdminRoute;